export default __webpack_public_path__ + "static/media/bt4.999a7010.jpg";